import { h } from 'preact'
import { Message } from '../../../../../lib/intl/Message'
import styles from './KommunevalgInfo.module.css'
import { useAppState } from '../../../../../lib/redux-provider-nohooks'
import { hasData } from '../../../../store/state'
import { isValgResultat } from '../../../../domain'
import { InfoHeading } from '../shared'

export function KommunevalgInfo() {
  return (
    <section class={styles.kommunevalgInfo}>
      <InfoHeading id="kommunevalg-footer-tittel" />
      <Message id="kommunevalg-footer-beskrivelse" />{' '}
      <a href="#fylkestingsvalg">
        <Message id={'kommunevalg-footer-lenketekst'} />
      </a>
    </section>
  )
}

function isPrognose(resultatType: 'Prognose' | 'Resultat' | 'PrognoseOverstyring') {
  return resultatType === 'Prognose' || resultatType === 'PrognoseOverstyring'
}

export function ConnectedKommunevalgInfo() {
  const state = useAppState()
  if (
    hasData(state.kommuneresultat) &&
    hasData(state.fylkesresultat) &&
    isValgResultat(state.fylkesresultat.data) &&
    isPrognose(state.fylkesresultat.data.resultatType)
  ) {
    return <KommunevalgInfo />
  } else {
    return null
  }
}
